import { Component, OnInit } from "@angular/core";
import { IVTableColumn } from "@app/directives/_layout/v-table/_models/IVTableColumn";
import { IVTableRow } from "@app/directives/_layout/v-table/_models/IVTableRow";
import { VTableService } from "@app/directives/_layout/v-table/_services/v-table.service";
import { IAutoDownloadSetting } from "@app/interfaces/IAutoDownloadSetting";
import { CameraLocation } from "@app/main/components/videos/enums/CameraLocation";
import { VideoEventCode } from "@app/main/components/videos/enums/VideoEventCode";
import { AutoDownloadSettingService } from "@app/services/autoDownloadSetting.service";
import { TranslationService } from "@app/services/translation.service";
import './auto-download-configuration.component.scss';

@Component({
    selector: 'auto-download-configuration',
    template: require('./auto-download-configuration.component.html')
})
export class AutoDownloadConfigurationComponent implements OnInit {

    settings: IAutoDownloadSetting[];
    selectedSetting: IAutoDownloadSetting;

    columns: IVTableColumn<IAutoDownloadSetting>[];
    rows: IVTableRow[] = [];
    filter: VideoEventCode[] = [];

    loading: boolean;
    deleting: boolean;

    constructor(
        private readonly translationService: TranslationService,
        private readonly vTableService: VTableService,
        private readonly autoDownloadSettingService: AutoDownloadSettingService
    ) {
    }

    ngOnInit(): void {
        this.createColumns();
        this.getData();
    }

    createNewSetting(): void {
        this.selectedSetting = this.autoDownloadSettingService.createDefaultSetting();
    }

    onRowClicked(row: IVTableRow): void {
        if (row?.data) {
            this.selectSetting(row.data);
        }
    }

    onCloseForm(): void {
        this.clearSelectedSetting();
    }

    onSettingSaved(): void {
        this.reset();
    }

    reset(): void {
        this.clearSelectedSetting();

        setTimeout(() => this.getData(), 1000);        
    }

    private getData(): void {
        this.settings = [];

        if (this.loading) {
            return;
        }

        this.loading = true;

        this.autoDownloadSettingService.getData().subscribe({
            next: (data: IAutoDownloadSetting[]) => {
                this.settings = data;
                this.createRows();
                this.createFilter();
            },
            complete: () => {
                this.loading = false;
            }
        });
    }

    private createColumns(): void {
        this.columns = [
            {
                header: this.vTableService.createTableHeader({ tKey: "AutoDownloadConfiguration.CameraEventType", sorted: true }),
                createCellFunction: record => this.vTableService.createTableCell(this.translationService.tEnum(VideoEventCode, "VideoEventCodeNewTranslations", record.EventType))
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "AutoDownloadConfiguration.Channel" }),
                createCellFunction: record => {
                    const locations = record.Channels.map(location => this.translationService.tEnum(CameraLocation, "CameraLocation", location)).join(", ");
                    return this.vTableService.createTableCell(locations);
                }
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "AutoDownloadConfiguration.VideoDuration" }),
                createCellFunction: record => {                    
                    return this.vTableService.createTableCell(`${record.VideoDuration}s`);
                }
            },

            /*

            {
                header: this.vTableService.createTableHeader({ tKey: "AutoDownloadConfiguration.DownloadQuality" }),
                createCellFunction: record => {
                    const label = record.IsHighDefinition ? this.translationService.t("AutoDownloadConfiguration.HdLabel") : this.translationService.t("AutoDownloadConfiguration.SdLabel");
                    return this.vTableService.createTableCell(label);
                }
            },
            */
            {
                header: this.vTableService.createTableHeader({ tKey: "AutoDownloadConfiguration.LastUpdated", width: 150 }),
                createCellFunction: record => this.vTableService.createDateCell(new Date(record.UpdatedTime))
            },
            {
                header: this.vTableService.createTableHeader({ tKey: "AutoDownloadConfiguration.Created", width: 150 }),
                createCellFunction: record => this.vTableService.createDateCell(new Date(record.CreatedTime))
            }
        ]
    }

    private createRows(): void {
        this.rows = this.vTableService.createTableRows(this.settings, this.columns);
    }

    private createFilter(): void {
        this.filter = [];

        this.settings.forEach(setting => {
            this.filter.push(setting.EventType);
        });
    }

    private selectSetting(setting: IAutoDownloadSetting): void {        
        this.selectedSetting =  JSON.parse(JSON.stringify(setting));
    }

    private clearSelectedSetting(): void {
        this.selectedSetting = null;
    }

}
